export default __webpack_public_path__ + "static/media/defaultTeamLogo.bb422264.png";